// shodné s online check-in formulářem

export const IDCARD_TYPE_ID = 1;
export const IDCARD_TYPE_PASSPORT = 2;

export const guestDetailFields = [
	{ name: 'firstname', label: 'GuestDetails.firstname' },
	{ name: 'surname', label: 'GuestDetails.surname' },
	{ name: 'sex', label: 'GuestDetails.sex' },
	{ name: 'birth_date', label: 'GuestDetails.birthDate' },
	{ name: 'citizenship_id', label: 'GuestDetails.citizenship' },
	{ name: 'idcard_type_id', label: 'GuestDetails.idcardType' },
	{ name: 'idcard_number', label: 'GuestDetails.idcardNumber' },
	{ name: 'street', label: 'GuestDetails.street' },
	{ name: 'city', label: 'GuestDetails.city' },
	{ name: 'zip', label: 'GuestDetails.zip' },
	{ name: 'country_id', label: 'GuestDetails.country' },
	{ name: 'signature', label: 'GuestDetails.signature' },
];

export function getSexOptions(t) {
	return [
		{ value: 'male', label: t('GuestDetails.sex.male') },
		{ value: 'female', label: t('GuestDetails.sex.female') },
	];
}

export function getIdcardTypeOptions(t) {
	return [
		{ value: IDCARD_TYPE_ID, label: t('GuestDetails.idcardType.id') },
		{ value: IDCARD_TYPE_PASSPORT, label: t('GuestDetails.idcardType.passport') },
	];
}

/**
 * Vrací, zda vybraná země vyžaduje vízum.
 *
 * @param {Array} countries
 * @param {number|string} countryId
 * @returns {boolean}
 */
export function isVisaRequiredForCountry(countries, countryId) {
	const id = parseInt(countryId, 10);
	return countries.some(country => country.id === id && country.isTravelVisaRequired);
}

/**
 * Vrací, zda je host - dle data narození - starší 15 let.
 *
 * @param {string} birthDate
 * @returns {boolean}
 */
export function isAtLeast15(birthDate) {
	if (!birthDate) return true;

	const parts = birthDate.split('.');
	if (parts.length !== 3) return true;

	const [day, month, year] = parts.map(part => parseInt(part, 10));
	if (!day || !month || !year) return true;

	const birthDateObj = new Date(year, month - 1, day);
	const fifteenYearsAgo = new Date();
	fifteenYearsAgo.setFullYear(fifteenYearsAgo.getFullYear() - 15);

	return birthDateObj <= fifteenYearsAgo;
}



// WEBPACK FOOTER //
// ./src/enums/GuestDetails.js